import { Component } from '@angular/core';

@Component({
  selector: 'app-microchipping-your-pet-v2',
  templateUrl: './microchipping-your-pet-v2.component.html',
  styleUrl: './microchipping-your-pet-v2.component.scss'
})
export class MicrochippingYourPetV2Component {}
